<ng-container [ngSwitch]="post.type">
  <ng-container *ngSwitchCase="'text'">
    <ark-ui-post-text
      (postClicked)="postClicked.emit($event)"
      (postImageClicked)="postImageClicked.emit($event)"
      [post]="post"
    ></ark-ui-post-text>
  </ng-container>
</ng-container>
